__webpack_require__.p = "/00000172-frontend/";